import React, { Component } from "react";
import moment from "moment";
import _ from "lodash";
import Waypoint from "react-waypoint";
import Scroll from "react-scroll";
import I18n from "../../../i18n/I18n";
import { Icon, ProductNameBox, Button, Modal } from "../../common";
import ItemNumber from "../../orders/itemNumber/ItemNumber";
import styles from "./PaymentDetails.scss";
import Helper from "../../../helper/Helper";
import DetailView from "../DetailView";
import { PaymentDetailsMobile } from "../index";

class PaymentDetails extends Component {
  constructor() {
    super();

    this.state = {
      showDetails: false,
      itemId: ""
    };
    this.toggleDetails = this.toggleDetails.bind(this);
  }

  toggleDetails(itemId) {
    this.setState({
      showDetails: true
    });
    this.props.getFinanceViewData(itemId);
  }

  onCloseModal() {
    this.setState({
      showDetails: false
    });
  }

  render() {
    const {
      paidAt,
      total,
      currencyCode,
      deductions,
      financeData,
      orderView,
      totalCredit,
      statementNr,
      user,
      paymentRef,
      seller,
      history,
      docType,
      loadFunc,
      scroll,
      scrollPage,
      showNoLoading
    } = this.props;
    const { showDetails, itemId } = this.state;
    const data = this.props.data || "";

    const property = Helper.validator(data);

    const listDetail =
      data && !_.isEmpty(data)
        ? data.map((payment, index) => {
            const currencyCode = this.props.currencyCode;
            return (
              <tr className={styles.row} key={index}>
                <td
                  className={styles.itemName}
                  onClick={this.toggleDetails.bind(this, payment.itemId)}
                >
                  <ProductNameBox hideBadge data={payment} />
                </td>
                <td>
                  <ItemNumber
                    itemNr={payment.itemNr}
                    seller={seller}
                    history={history}
                  />
                </td>
                <td onClick={this.toggleDetails.bind(this, payment.itemId)}>
                  {payment.sku}
                </td>
                <td onClick={this.toggleDetails.bind(this, payment.itemId)}>
                  {payment.partnerSku}
                </td>
                {property.haveVal("direct_collection_fee") ? (
                  <td onClick={this.toggleDetails.bind(this, payment.itemId)}>
                    {payment.direct_collection_fee}
                  </td>
                ) : (
                  ""
                )}
                {property.haveVal("fx_rate_payment") ? (
                  <td onClick={this.toggleDetails.bind(this, payment.itemId)}>
                    {payment.fx_rate_payment}
                  </td>
                ) : (
                  ""
                )}
                <td onClick={this.toggleDetails.bind(this, payment.itemId)}>
                  {1}
                </td>
                <td onClick={this.toggleDetails.bind(this, payment.itemId)}>
                  <span
                    className={`${
                      payment.netDue < 0 ? styles.negative : styles.positive
                    }`}
                  >
                    {payment.netDue > 0 && "+"}&nbsp;{I18n.formatCurrency(
                      Helper.formatPrice(payment.netDue, currencyCode)
                    )}
                  </span>
                </td>
              </tr>
            );
          })
        : "";

    const documentListDetail =
      data && !_.isEmpty(data)
        ? data.map((payment, index) => {
            const currencyCode = this.props.currencyCode;
            return (
              <tr className={styles.row} key={index}>
                <td className={styles.itemName}>
                  {payment && payment.document_reference}
                </td>
                <td>{payment && payment.document_type}</td>
                <td>{payment && payment.code}</td>
                <td>{payment && payment.fx_rate_payment}</td>
                <td>
                  <span
                    className={`${
                      payment.net_due < 0 ? styles.negative : styles.positive
                    }`}
                  >
                    {payment.net_due > 0 && "+"}&nbsp;{I18n.formatCurrency(
                      Helper.formatPrice(payment.net_due, currencyCode)
                    )}
                  </span>
                </td>
              </tr>
            );
          })
        : "";

    /* Payment Details List for Mobile */
    const listDetailMobile = (
      <div>
        <PaymentDetailsMobile
          data={this.props.data}
          currencyCode={currencyCode}
          totalCredit={totalCredit}
          deductions={deductions}
          total={total}
          seller={seller}
          history={history}
          toggleDetails={this.toggleDetails}
          docType={docType}
          scrollPage={scrollPage}
          scroll
          loadFunc={loadFunc}
          showNoLoading={showNoLoading}
        />
      </div>
    );

    return (
      <div className={styles.ctr}>
        {docType === 1 ? (
          <div className={styles.btnWrapper}>
            <Button
              className={styles.flexer}
              variant="transparent"
              onClick={() => this.props.exportStatements(statementNr)}
            >
              <Icon name="download" className={styles.icon} />
              {I18n.getText(
                "statement.export-statement",
                {},
                "Export Statement"
              )}
            </Button>
          </div>
        ) : (
          ""
        )}

        {/* Payment Details table for Desktop */}
        {this.props.browser && this.props.browser.greaterThan.tablet ? (
          <div className={styles.scrollCtr}>
            <div className={styles.tableWrapper}>
              <table className={styles.table}>
                <thead>
                  {docType === 1 ? (
                    <tr className={`${styles.row} ${styles.head}`}>
                      <th>
                        {I18n.getText("statement-details.name", {}, "Name")}
                      </th>
                      <th>
                        {I18n.getText(
                          "statement-details.item-no",
                          {},
                          "Item No."
                        )}
                      </th>
                      <th>
                        {I18n.getText("statement-details.sku", {}, "SKU")}
                      </th>
                      <th>
                        {I18n.getText(
                          "statement-details.partner-sku",
                          {},
                          "Partner SKU"
                        )}
                      </th>
                      {property.haveVal("direct_collection_fee") ? (
                        <th>
                          {I18n.getText(
                            "statement-details.collection-fee",
                            {},
                            "collection Fee"
                          )}
                        </th>
                      ) : (
                        ""
                      )}
                      {property.haveVal("fx_rate_payment") ? (
                        <th>
                          {I18n.getText(
                            "statement-details.fx-rate",
                            {},
                            "FX rate"
                          )}
                        </th>
                      ) : (
                        ""
                      )}
                      <th>
                        {I18n.getText("statement-details.units", {}, "units")}
                      </th>
                      <th>
                        {I18n.getText(
                          "statement-details.total",
                          { currency: currencyCode },
                          "Subtotal ({currency})"
                        )}
                      </th>
                    </tr>
                  ) : (
                    <tr className={`${styles.row} ${styles.head}`}>
                      <th>
                        {I18n.getText(
                          "statement-details.ref-no",
                          {},
                          "Reference Number"
                        )}
                      </th>
                      <th>
                        {I18n.getText(
                          "statement-details.document-ref",
                          {},
                          "Document Type"
                        )}
                      </th>
                      <th>
                        {I18n.getText(
                          "statement-details.document-currency",
                          {},
                          "Currency"
                        )}
                      </th>
                      <th>
                        {I18n.getText(
                          "statement-details.fx-rate-payment",
                          {},
                          "FX Rate"
                        )}
                      </th>
                      <th>
                        {I18n.getText(
                          "statement-details.net-due",
                          {},
                          "Amount"
                        )}
                      </th>
                    </tr>
                  )}
                </thead>
                <tbody>
                  {docType === 1 ? listDetail : documentListDetail}
                  {loadFunc && scroll && data && !_.isEmpty(data) ? (
                    <div>
                      <Waypoint onEnter={loadFunc} />
                      {!showNoLoading && <div>Loading...</div>}
                    </div>
                  ) : (
                    ""
                  )}
                </tbody>
              </table>
            </div>
            <div className={styles.bottom}>
              <div>
                <div className={styles.subTotal}>
                  <p>
                    {I18n.getText(
                      "statement-details.subtotal",
                      {},
                      "SubTotal"
                    )}
                  </p>
                  <div className={styles.val}>
                    {I18n.formatCurrency(
                      Helper.formatPrice(totalCredit, currencyCode)
                    )}
                  </div>
                </div>
                <div className={styles.subTotal}>
                  <p>
                    {I18n.getText(
                      "statement-details.deductions",
                      {},
                      "Total Deductions"
                    )}
                  </p>
                  <div className={styles.val}>
                    {I18n.formatCurrency(
                      Helper.formatPrice(deductions, currencyCode)
                    )}
                  </div>
                </div>
              </div>
              {/* <div>
                <div>
                  <span className={styles.bottomTotal}>
                    {I18n.formatCurrency(
                      Helper.formatPrice(total, currencyCode)
                    )}
                  </span>
                </div>
              </div> */}
            </div>
          </div>
        ) : (
          listDetailMobile
        )}

        {showDetails && (
          <Modal
            contentLabel={"Change Email"}
            isOpen={this.state.showDetails}
            closeModal={() => this.onCloseModal()}
          >
            {financeData &&
              orderView && (
                <DetailView
                  user={user}
                  financeView={financeData}
                  isFinanceLoading={this.props.isFinanceLoading}
                  orderView={orderView}
                  currencyCode={currencyCode}
                />
              )}
          </Modal>
        )}
      </div>
    );
  }
}

export default PaymentDetails;



// WEBPACK FOOTER //
// ./src/components/statement/paymentDetails/PaymentDetails.js